import LevelMeta from '../types/LevelMeta';
import SegmentedButtonGroup from '../../../components/input/buttons/segmented/SegmentedButtonGroup';
import { LevelFlag } from '@gdladder/shared/enums';

interface Props {
    levelFlags: number;
    levelMeta: LevelMeta;
    showTwoPlayerStats: boolean;
    setShowTwoPlayerStats: (show: boolean) => void;
}

export default function TwoPlayerButtons({ levelFlags, levelMeta, showTwoPlayerStats, setShowTwoPlayerStats }: Props) {
    if (!levelMeta.IsTwoPlayer) return;
    if (levelFlags & LevelFlag.IS_MINIGAME) return;

    return (
        <div className='mb-2 max-w-40'>
            <SegmentedButtonGroup
                options={twoPlayerOptions}
                activeKey={showTwoPlayerStats ? 'twoPlayer' : 'singlePlayer'}
                onSetActive={(key) => setShowTwoPlayerStats(key === 'twoPlayer')}
            />
        </div>
    );
}

const twoPlayerOptions = {
    singlePlayer: '1P',
    twoPlayer: '2P',
} as const;
